<template>
    <!-- Loading -->
    <b-overlay :show="form.busy || loading">
        <div class="row">
            <div class="col-12 col-sm-5 mx-auto py-4">
                <!-- Form -->
                <form @submit.prevent="submit" novalidate="true">

                        <!-- Field -->
                        <b-form-group :label="__('configuration.Default Number Format')">
                            <select v-model="form.fk_number_format" class="form-control" :class="{ 'is-invalid': form.errors.has('fk_number_format') }">
                                <option value="1">10.520,85</option>
                                <option value="2">10520.85</option>
                            </select>
                            <has-error :form="form" field="fk_number_format"></has-error>
                        </b-form-group>

                        <!-- Field -->
                        <b-form-group :label="__('configuration.Default Stake')">
                            <currency-input
                                :locale="locale"
                                :currency='currency'
                                class="form-control font-weight-bold"
                                v-bind:class="{'is-invalid': form.errors.has('stake'), 'text-muted': form.stake === 0, 'text-success': form.stake > 0, 'text-danger': form.stake < 0}"
                                v-model="form.stake"
                            />
                            <has-error :form="form" field="stake"></has-error>
                        </b-form-group>

                        <!-- Field -->
                        <b-form-group :label="__('configuration.Default Sport')">
                            <select v-model="form.fk_sport" class="form-control" :class="{ 'is-invalid': form.errors.has('fk_sport') }">
                                <option v-for="sport in sports" :key="sport.id" :value="sport.id">{{ sport.name }}</option>
                            </select>
                            <has-error :form="form" field="fk_sport"></has-error>
                        </b-form-group>

                        <!-- Field -->
                        <b-form-group :label="__('configuration.Default Bankroll')">
                            <select v-model="form.fk_bankroll" class="form-control" :class="{ 'is-invalid': form.errors.has('fk_bankroll') }">
                                <option v-for="bankroll in bankrolls" :key="bankroll.id" :value="bankroll.id">{{ bankroll.name }}</option>
                            </select>
                            <has-error :form="form" field="fk_bankroll"></has-error>
                        </b-form-group>

                        <!-- Field -->
                        <b-form-group :label="__('configuration.Default Date Range')">
                            <select v-model="form.date_range" class="form-control" :class="{ 'is-invalid': form.errors.has('date_range') }">
                                <option value="this_month">{{ __('configuration.This Month') }}</option>
                                <option value="last_30_days">{{ __('configuration.Last') }} 30 {{ __('configuration.Days') }}</option>
                                <option value="last_3_months">{{ __('configuration.Last') }} 3 {{ __('configuration.Months') }}</option>
                                <option value="last_6_months">{{ __('configuration.Last') }} 6 {{ __('configuration.Months') }}</option>
                            </select>
                            <has-error :form="form" field="date_range"></has-error>
                        </b-form-group>

                        <b-form-group>
                            <!-- Submit -->
                            <b-button type="submit" variant="primary" :disabled="form.busy">
                                {{ __('configuration.Save') }}
                            </b-button>
                        </b-form-group>

                    </form>
            </div>
        </div>
    </b-overlay>
</template>

<script>
import { Form } from "vform";

export default {
    props: ['locale', 'currency'],
    data() {
        return {
            loading: false,
            form: new Form({
                stake: 0,
                fk_sport: 0,
                fk_bankroll: null,
                fk_number_format: null,
                date_range: null,
            }),
            sports: [],
            bankrolls: []
        }
    },
    mounted() {
        this.load()
    },
    methods: {

        load() {
            this.loading = true
            axios.get('/configurations/general/default')
                .then((result) => {

                    this.sports = result.sports;
                    this.bankrolls = result.bankrolls;

                    // Fill Defaults
                    if (result.defaults) {
                        this.form.fill({
                            stake: result.defaults.stake,
                            fk_sport: result.defaults.fk_sport,
                            fk_bankroll: result.defaults.fk_bankroll,
                            fk_number_format: result.defaults.fk_number_format,
                            date_range: result.defaults.date_range,
                        })
                    }

                })
                .finally(() => this.loading = false)
        },

        submit() {
            this.form.put('/' + this.locale + '/configurations/general/default')
                .then(result => {
                    window.location.reload();
                })
        },

    }
}
</script>

<style scoped>

</style>
